import { render, staticRenderFns } from "./MidTab.vue?vue&type=template&id=6e31ab9b&scoped=true&"
import script from "./MidTab.vue?vue&type=script&lang=ts&"
export * from "./MidTab.vue?vue&type=script&lang=ts&"
import style0 from "./mid_tab.scss?vue&type=style&index=0&id=6e31ab9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e31ab9b",
  null
  
)

export default component.exports